
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';

async function initializeApp() {
    console.log('🚀 Starting application initialization...');
    console.log('🌍 Environment:', {
        url: window.location.href,
        origin: window.location.origin,
        pathname: window.location.pathname,
        search: window.location.search,
        userAgent: navigator.userAgent.substring(0, 100) + '...'
    });

    try {
        const platformRef = platformBrowserDynamic();
        const moduleRef = await platformRef.bootstrapModule(AppModule);

        console.log('📱 Angular app bootstrapped successfully');
        return { success: true };

    } catch (error) {
        console.error('💥 Application initialization failed:', error);
        return { success: false };
    }
}

// Run initialization
initializeApp().then(result => {
    if (result.success) {
        console.log('🎉 Application started successfully!');
    } else {
        console.warn('⚠️ Application started with issues');
    }
}).catch(error => {
    console.error('💥 Fatal initialization error:', error);
});
